<template>
    <div class="success-email__content" v-bind:class="{ authorized: accessToken }">
        <Sidebar v-show="accessToken"></Sidebar>
      <div class="no-autorized__img"></div>
        <div class="content-wrapper success-email__wrapper">
            <div class="img-desktop img-desktop-success d-none d-lg-inline-block"></div>

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-7 col-centered">
                            <div class="alert alert-success alert-dismissible">
                                <h5>
                                    <span>
                                        <i class="icon fas fa-check"></i>
                                        <span>{{ message }}</span>
                                    </span>
                                </h5>
                            </div>
                        </div>
                        <div v-if="shortCode ==='reset_password_check_email'"
                            class="col-md-7 col-centered text-center"
                        >
                            <router-link tag="button"
                                         class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                         :to="{ name: 'login' }"
                            >Retour à l'écran de connexion</router-link>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../components/Footer';
    import Sidebar from '../components/Sidebar';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                shortCodeToMessageMap: {
                    'exemption_approved': `La demande de dispense a bien été validée et archivée.
                        Vous pouvez la consulter sur la page Recherche des dispenses`,
                    'exemption_rejected': `La demande de dispense a bien été refusée et archivée.
                        Vous pouvez la consulter sur la page Recherche des dispenses`,
                    'contact_lawyers_email': `L'email a été envoyé.`,
                    'reset_password_check_email': `Merci de consulter vos emails`,
                    'due_sign': `La DUE a bien été signée et sauvegardée. Prochaine étape :
                        communiquer aux salariés pour rendre la DUE opposable, en respectant les
                        formalités que nous avons détaillées à l'attention du gestionnaire.`,
                    'exemption_sign': `Vous avez signé avec succès votre demande de dispense
                        d'affiliation au régime de mutuelle de votre entreprise. Votre demande va
                        être examinée rapidement et vous serez informé du résultat par email.`,
                    'app_contact_us_email': `L'email a été envoyé. Nous vous recontacterons dans
                        les plus brefs délais`,
                    'confirm_exemption': `Vous avez complété avec succès votre demande de dispense
                        d'affiliation au régime de mutuelle de votre entreprise. Votre demande va être
                        examinée rapidement et vous serez informé du résultat par email.`,
                    'confirm_exemption_aborted': 'Votre demande de dispense a bien été abandonnée'
                }
            }
        },
        computed: {
            ...mapGetters({
                accessToken: 'accessToken'
            }),
            shortCode() {
                return this.$route.params.messageShortCode;
            },
            message() {
                return this.shortCodeToMessageMap[this.shortCode] ?? 'Success';
            },
        },
        components: {
            Footer,
            Sidebar
        }
    }
</script>
